import { createSlice } from "@reduxjs/toolkit";

const timeSheetMasterSlice = createSlice({
    name: "timeSheetMaster",
    initialState: {
        isLoading: false,
        rolePaginationList: [],
        timeSheetRole: {}
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setRolePaginationList(state, action) {
            state.rolePaginationList = action.payload;
        },
        setTimeSheetRole(state, action) {
            state.timeSheetRole = action.payload;
        },
    },
});

export const { setIsLoading, setRolePaginationList, setTimeSheetRole } = timeSheetMasterSlice.actions;
export default timeSheetMasterSlice.reducer;